export default function() {
  return {
    state: {
      tryingToPublish: false,
      tryingToRequestPublish: false
    },
    mutations: {
      tryPublish(state) {
        state.tryingToPublish = true;
      },
      stopTryPublish(state) {
        state.tryingToPublish = false;
      },
      tryRequestPublish(state) {
        state.tryingToRequestPublish = true;
      },
      stopTryRequestPublish(state) {
        state.tryingToRequestPublish = false;
      },
      stopValidation(state) {
        state.tryingToPublish = false;
        state.tryingToRequestPublish = false;
      }
    }
  };
}
